import { AppThunk, RootState } from "@/store";
import { RequestQueueItem } from "@/types/requestQueue";

import {
    addOrReplaceRequestQueueItem,
    addRequestQueueItem,
} from "./offline.slice";

type QueueItemPayload = Omit<RequestQueueItem, "status" | "createdAt">;

const resolveQueueMetadata = (
    state: RootState,
    metadata?: RequestQueueItem["metadata"],
): RequestQueueItem["metadata"] => {
    if (!metadata) return metadata;

    const nextMetadata: RequestQueueItem["metadata"] = { ...metadata };

    const marketId = nextMetadata.marketId;
    const taskId = nextMetadata.taskId;

    if (marketId && !nextMetadata.marketName) {
        nextMetadata.marketName = state.work.markets?.[marketId]?.name;
    }

    if (marketId && taskId && !nextMetadata.taskName) {
        nextMetadata.taskName = state.work.tasks?.[marketId]?.[taskId]?.name;
    }

    return nextMetadata;
};

export const enqueueRequestQueueItem =
    (payload: QueueItemPayload): AppThunk =>
    (dispatch, getState) => {
        dispatch(
            addRequestQueueItem({
                ...payload,
                metadata: resolveQueueMetadata(getState(), payload.metadata),
            }),
        );
    };

export const enqueueOrReplaceRequestQueueItem =
    (payload: QueueItemPayload): AppThunk =>
    (dispatch, getState) => {
        dispatch(
            addOrReplaceRequestQueueItem({
                ...payload,
                metadata: resolveQueueMetadata(getState(), payload.metadata),
            }),
        );
    };
